import { render, staticRenderFns } from "./state-of-residence.vue?vue&type=template&id=08aa3543&scoped=true&lang=pug&"
import script from "./state-of-residence.vue?vue&type=script&lang=js&"
export * from "./state-of-residence.vue?vue&type=script&lang=js&"
import style0 from "./state-of-residence.vue?vue&type=style&index=0&id=08aa3543&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aa3543",
  null
  
)

export default component.exports